import { render } from "./HsIcon.vue?vue&type=template&id=4c8d9b3a&scoped=true"
import script from "./HsIcon.vue?vue&type=script&lang=js"
export * from "./HsIcon.vue?vue&type=script&lang=js"

import "./HsIcon.vue?vue&type=style&index=0&id=4c8d9b3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8d9b3a"]])

export default __exports__